import styled from 'styled-components';
import { ProSkill } from './ProSkill';
import { proSkills } from '../../data/proSkills';

export const ProSkills = () => {
  return (
    <ProSkillsStyled>
      <div className='title'>
        <h2>Professional Skills</h2>
        <div className='underline'></div>
      </div>
      <div className='skills-content'>
        {proSkills.map((skill, index) => (
          <ProSkill key={index} title={skill.title} text={skill.text} />
        ))}
      </div>
    </ProSkillsStyled>
  );
};

const ProSkillsStyled = styled.div`
  .title {
    margin-bottom: 2rem;
    h2 {
      font-size: 2.5rem;
      margin-bottom: 1rem;
    }
    .underline {
      width: 5rem;
      height: 0.3rem;
      background: var(--primary-color);
    }
  }

  .skills-content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1.5rem;
    width: 100%;
    margin-bottom: 1rem;
    @media screen and (max-width: 650px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;
